import cn from 'classnames'
import styled from 'styled-components'

import theme from '../../../utils/theme'

const ContentWrap = styled.div.withConfig({
  shouldForwardProp: prop => !['fullHeight'].includes(prop),
})`
  display: flex;
  padding: 18px;
  background-color: ${`var(--gameday-mainNav-sidebarBgColor, ${theme.mainNav.sidebarBgColor})`};
  border-radius: 0 8px 8px 8px;
  min-height: ${props => (props.fullHeight ? '100vh' : 'auto')};
  &.col-right {
    aside {
      margin: 0 0 0 18px;
    }
  }
  @media (max-width: 768px) {
    flex-direction: column;
    &.col-right {
      main {
        flex-grow: initial;
      }
      aside {
        margin: 18px 0 0 0;
      }
    }
    aside {
      flex-basis: 100%;
      margin: 0 0 18px 0;
    }
  }
  &.no-padding {
    padding: 0;
    min-height: auto;
  }
`

const FeatureColumn = styled.aside.withConfig({
  shouldForwardProp: prop => !['columnWidth'].includes(prop),
})`
  width: ${props => props.columnWidth};
  margin-right: 18px;
  flex-shrink: 0;
  img {
    max-width: 100%;
  }
`

const Content = styled.main.withConfig({
  shouldForwardProp: prop => !['columnWidth'].includes(prop),
})`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const PageContent = ({ children, column, columnRight, columnWidth, fullHeight, noPadding, className }) => (
  <ContentWrap
    className={cn(
      columnRight && 'col-right',
      {
        'no-padding': noPadding,
      },
      className
    )}
    fullHeight={fullHeight}
  >
    {column && !columnRight && <FeatureColumn columnWidth={columnWidth}>{column}</FeatureColumn>}
    <Content columnWidth={columnWidth}>{children}</Content>
    {column && columnRight && <FeatureColumn columnWidth={columnWidth}>{column}</FeatureColumn>}
  </ContentWrap>
)

PageContent.defaultProps = {
  columnRight: false,
  columnWidth: '200px',
  fullHeight: false,
}

export default PageContent
